import _ from 'lodash'

export default class BlackBoxAPI{
    constructor(){
        this.lista = []
        this.filtroLideres = []
    }
    reset() {
        this.lista = []
        this.filtroLideres = []
    }
    add(detalle){
        this.lista.push(detalle)
    }
    /*** ################### FILTROS ################### ***/
    actualizarFiltros(){
        this.filtroLideres = _.chain(this.lista)
            .map(detalle=>{
                let valor = detalle.codigo
                let texto = detalle.lider
                let opcion = _.find(this.filtroLideres, {'valor': valor})
                return opcion? opcion : {valor, texto, seleccionado: true}
            })
            .uniqBy('valor')
            .sortBy('valor')
            .value()
    }
    ordenarLista(){
        let porLider = (detalle)=> detalle.codigo
        this.lista = _.orderBy(this.lista, [porLider], ['asc', 'asc', 'desc'])
    }
    reemplazarFiltro(nombreFiltro, filtroActualizado) {
        if(this[nombreFiltro]) {
            this[nombreFiltro] = filtroActualizado
        }else{
            console.error(`Filtro ${nombreFiltro} no existe.`)
        }
    }

    getListaFiltrada(){
        this.actualizarFiltros()
        var detFiltrado = _.chain(this.lista)
            .filter(detalle=>{
                return _.find(this.filtroLideres, {'valor': detalle.codigo, 'seleccionado': true})
            })
            .value()
        return {
            totalDisponible: detFiltrado[0]['disponible'],
            totalReal: _.sumBy(detFiltrado,'real'),
            totalNecesarias: _.sumBy(detFiltrado,'necesarias'),
            totalExcedente: _.sumBy(detFiltrado,'excedente'),
            totalFaltantes: _.sumBy(detFiltrado,'faltantes'),
            detallesFiltrados: detFiltrado,
            filtros: {
                filtroLideres: this.filtroLideres
            }
        }
    }
}



// WEBPACK FOOTER //
// ./frontEnd/inventarios/programacion-semanal/BlackBoxAPI.js